import http from './http'
import malaDireta from './mala-direta'

export default {
  http,
  malaDireta
}
